<template>
  <div class="ec-day">
    <HourSlotComponent
      v-for="(hour, ind) in hours"
      :key="ind"
      :jobs-per-hour="_dayEvents[hour]"
    />
  </div>
</template>

<script setup>
import HourSlotComponent from "./HourSlotComponent.vue";
import { watchEffect, ref } from "vue";
const props = defineProps({
  events: {
    type: Array,
    default: () => [],
  },
  date: {
    type: String,
    default: "",
  },
});
const hours = [8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20];

function countServiceIDs(events) {
  const result = {
    8: {},
    9: {},
    10: {},
    11: {},
    12: {},
    13: {},
    14: {},
    15: {},
    16: {},
    17: {},
    18: {},
    19: {},
    20: {},
  };

  events.forEach((event) => {
    const hourSlot = event.datetime.getUTCHours(); // Get the hour of the event
    const key = hourSlot;
    event.service_id.forEach((serviceId) => {
      if (!result[key][serviceId]) {
        result[key][serviceId] = [];
      }
      result[key][serviceId].push(event);
    });
  });
  return result;
}

const _dayEvents = ref({});
watchEffect(() => {
  _dayEvents.value = countServiceIDs(props.events);
});
</script>
<style scoped>
.ec-time {
  height: 100px;
}
</style>
